import { ReducerRegistry } from 'store';
import {
  LOGIN,
  AUTH_ASYNC_START,
  AUTH_LOG_ERROR,
  LOGIN_PAGE_UNLOADED,
  SET_RESET_DETAILS,
  AUTH_TEAM_MEMBER_PASSWORD,
} from '../types';

const INIT_STATE = {
  inProgress: false,
  error: null,
  user: {},
  resetDetails: {},
};

export const authReducer = ReducerRegistry.register(
  'auth',
  (state = INIT_STATE, action) => {
    switch (action.type) {
      case LOGIN:
        return {
          ...state,
          user: action.user,
          inProgress: false,
        };
      case SET_RESET_DETAILS:
        return {
          ...state,
          resetDetails: action.reset,
          inProgress: false,
        };
      case AUTH_ASYNC_START:
        return {
          ...state,
          inProgress: action.loading,
        };
      case AUTH_LOG_ERROR:
        return {
          ...state,
          inProgress: false,
          error:
            action.error || 'Sorry, something went wrong. Please try again',
        };
      case AUTH_TEAM_MEMBER_PASSWORD:
        return { ...state, inProgress: action.payload };
      case LOGIN_PAGE_UNLOADED:
        return INIT_STATE;
      default:
        return state;
    }
  }
);
